import React from 'react';
import { Sounds } from '../../../@resources/sounds';
import { useObserver } from '../../../CodesThatsGottaGoSomewhereElse';
import { LabelValue } from '../../../platform/types/LabelValue';
import { Menu } from '../../../ui';
import { PopoutWidget } from '../../canvas/workspace/widgets/WidgetInterface';
import { Flexer } from '../../dashboard/elements/LayoutElements';

const voters = [
    LabelValue('Voter 1', Sounds.Buzzer1),
    LabelValue('Voter 2', Sounds.Buzzer2),
    LabelValue('Voter 3', Sounds.Buzzer3),
    LabelValue('Voter 4', Sounds.Buzzer4),
    LabelValue('Voter 5', Sounds.Buzzer5),
];

export const VoterSoundWidget = ({ widget }: { widget: PopoutWidget }) => {
    useObserver(widget);

    const onSelect = (x: LabelValue) => {
        widget.update({ value: x.value, open: false });
    };

    return <Flexer width="12.5">
        <Menu>
            <Menu.Section title="Voter Sounds" first>
                {voters.map(x =>
                    <Menu.Item key={x.value} onClick={() => onSelect(x)} checked={x.value === widget.value}>
                        <Menu.ItemText>{x.label}</Menu.ItemText>
                    </Menu.Item>
                )}
            </Menu.Section>
        </Menu>
    </Flexer>;
};
